import type {
    AddJobSeekerProfileStructuredDataAttributesInput,
    JobSeekerProfileStructuredDataSentiment,
    JobSeekerProfileStructuredDataTaxonomyConceptInput,
} from '../../../../../../../../__generated__/types.gqlgenerated';
import type { QualificationAttribute } from '../../../types/JobAttribute';

import YellowLightCategoryType from '../../../types/YellowLightCategoryType';

export const getAttributesInput = (
    attribute: QualificationAttribute,
    sentiment: boolean,
): AddJobSeekerProfileStructuredDataAttributesInput => {
    const requirementType = getAttributesInputKey(attribute.type);

    return {
        [requirementType]: [buildTypeInput(attribute, sentiment)],
    };
};

const buildTypeInput = (attribute: QualificationAttribute, sentiment: boolean) => {
    const taxonomyConceptKey: string = getTaxonomyConceptFieldName(attribute.type);

    return {
        [taxonomyConceptKey]: getConceptInput(attribute),
        sentiment: getSentimentInput(sentiment),
    };
};

const getSentimentInput = (sentiment: boolean): JobSeekerProfileStructuredDataSentiment => {
    return sentiment ? 'POSITIVE' : 'NEGATIVE';
};

const getConceptInput = ({
    label,
    suid,
    uuid,
}: QualificationAttribute): JobSeekerProfileStructuredDataTaxonomyConceptInput => {
    return {
        label,
        suid,
        uuid,
        sectionIds: [],
    };
};

const getTaxonomyConceptFieldName = (categoryType: YellowLightCategoryType): string => {
    switch (categoryType) {
        case YellowLightCategoryType.CERTIFICATIONS:
            return 'certificationTaxonomyConcept';
        case YellowLightCategoryType.EDUCATION:
            return 'degreeTaxonomyConcept';
        case YellowLightCategoryType.LANGUAGES:
            return 'languageTaxonomyConcept';
        case YellowLightCategoryType.LICENSE:
            return 'licenseTaxonomyConcept';
        case YellowLightCategoryType.OCCUPATION:
            return 'occupationTaxonomyConcept';
        case YellowLightCategoryType.SKILLS:
            return 'skillTaxonomyConcept';
        case YellowLightCategoryType.WORK_EXPERIENCE:
            return 'occupationTaxonomyConcept';
        default:
            throw new Error('Taxonomy concept type not supported');
    }
};

const getAttributesInputKey = (categoryType: YellowLightCategoryType): string => {
    switch (categoryType) {
        case YellowLightCategoryType.CERTIFICATIONS:
            return 'certifications';
        case YellowLightCategoryType.EDUCATION:
            return 'educations';
        case YellowLightCategoryType.LANGUAGES:
            return 'languages';
        case YellowLightCategoryType.LICENSE:
            return 'licenses';
        case YellowLightCategoryType.OCCUPATION:
            return 'occupations';
        case YellowLightCategoryType.SKILLS:
            return 'skills';
        case YellowLightCategoryType.WORK_EXPERIENCE:
            return 'workExperiences';
        default:
            throw new Error('Taxonomy concept type not supported');
    }
};
